<template>
  <v-container fluid class="pa-4">
    <v-row class="mb-6">
      <v-col cols="12">
        <div class="d-flex align-center mb-2">
          <v-avatar size="56" class="mr-4 primary">
            <v-icon size="32" color="white">mdi-file-document-multiple</v-icon>
          </v-avatar>
          <div>
            <h1 class="display-1 mb-1 font-weight-bold">My Documents</h1>
            <p class="subtitle-1 grey--text text--darken-1 mb-0">
              Download a current copy of your enrollment paperwork any time
            </p>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col v-for="doc in documents" :key="doc.key" cols="12" md="6" lg="4">
        <v-card class="fill-height d-flex flex-column" elevation="3">
          <v-card-title class="primary white--text py-3">
            <v-icon left color="white">{{ doc.icon }}</v-icon>
            {{ doc.title }}
          </v-card-title>
          <v-card-text class="flex-grow-1 pa-4">
            {{ doc.description }}
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="pa-4">
            <v-btn
              block
              color="primary"
              @click="download(doc)"
              :loading="downloading === doc.key"
            >
              <v-icon left>mdi-download</v-icon>
              Download PDF
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="4000" top>
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar.show = false">Close</v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'MyDocuments',
  data() {
    return {
      downloading: null,
      snackbar: { show: false, message: '', color: 'success' },
      documents: [
        {
          key: 'enrollment-summary',
          title: 'Enrollment Summary',
          icon: 'mdi-file-account',
          description: 'Your plan, dependents, pricing per benefit and effective date.',
          url: '/api/member-payments/documents/enrollment-summary.pdf',
          filename: 'enrollment-summary.pdf',
        },
        {
          key: 'member-agreement',
          title: 'Member Agreement',
          icon: 'mdi-file-sign',
          description: 'The plan agreement for the coverage you signed up for.',
          url: '/api/member-payments/documents/member-agreement.pdf',
          filename: 'member-agreement.pdf',
        },
        {
          key: 'welcome-letter',
          title: 'Welcome Letter',
          icon: 'mdi-file-document-outline',
          description: 'The welcome booklet sent when you first enrolled (English/Spanish).',
          url: '/api/member-payments/documents/welcome-letter.pdf',
          filename: 'welcome-letter.pdf',
        },
      ],
    };
  },
  methods: {
    async download(doc) {
      this.downloading = doc.key;
      try {
        const response = await axios.get(doc.url, { responseType: 'blob' });
        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = fileURL;
        link.setAttribute('download', doc.filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(fileURL);
      } catch (err) {
        console.error(`Error downloading ${doc.key}:`, err);
        // responseType 'blob' means an error JSON body also arrives as a Blob — read it back
        // as text so the real backend message reaches the snackbar instead of a generic one.
        let detail = err.message || '';
        if (err.response && err.response.data instanceof Blob) {
          try {
            const text = await err.response.data.text();
            const parsed = JSON.parse(text);
            detail = parsed.details || parsed.error || detail;
          } catch (_) {
            /* not JSON, keep err.message */
          }
        }
        this.snackbar.message = `Could not download ${doc.title}.${detail ? ` ${detail}` : ' Please try again.'}`;
        this.snackbar.color = 'error';
        this.snackbar.show = true;
      } finally {
        this.downloading = null;
      }
    },
  },
};
</script>
